<template>
  <div class="border border-3">    
    <button
      :disabled="current.estatus == false || current.limitar_listado == false"
      class="btn btn-success btn-block"
      @click="abrirModalAgregarDetalle()"
    >
      <i class="fas fa-plus"></i> Agregar productos al cupon
    </button>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="nuevaOrdenCompraModal"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg" role="document" style="max-width: 80%">
        <div
          class="modal-content text-center"
          style="width: 100%; max-width: 100%"
        >
          <button
            aria-label="Close"
            class="close"
            @click="cerrarModal()"
            type="button"
          >
            <span class="close-label">Cerrar</span
            ><span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-content with-gradient">
            <h5 class="modal-title text-success">Agregar productos a cupón</h5>
            <br />
            <div class="row">
              <div class="col-md-6 col-lg-3">
                <ProductoSelectComponent :current="filter" />
              </div>
              <div class="col-md-6 col-lg-2">
                <ProveedoresSelectComponent :current="filter" />
              </div>
              <div class="col-md-5 col-lg-3">
                <CategoriaSelectComponent :current="filter" />
              </div>  
              <div class="col-md-5 col-lg-3">
                <SubCategoriaSelectComponent :current="filter" />
              </div>               
              <div class="mt-3 btn-group" style="height:30px">                
                <button
                  @click="refreshtablaAgregarProductos()"
                  class="btn btn-success"
                >
                  <i class="fas fa-search"></i>
                </button>
                <button class="btn ml-0" style="background-color: transparent;"
                  @click="cleanDataFilter()">
                  <i class="text-danger fa fa-times fa-lg"></i>
                </button> 
              </div>
              <div class="col-12">
                <button
                  @click="agregar_lista_productos()"
                  class="btn btn-success btn-block btn-sm mt-3"
                  :disabled = "tablaProducto && tablaProducto.count === 0"
                >
                  Agregar toda la lista
                </button>
              </div>
              <div v-if="errors" class="col-12 text-center mt-3">                
                  <h6 class="text-danger" >
                    {{errors}}
                  </h6>
              </div>
              <!-------------------- END - Controles arriba de tabla-------------------->
              <div
                style="overflow-y: scroll; max-height: 700px"
                class="table-responsive mt-3"
                v-if="tablaProducto.count>0"
              >
                <!-------------------- Tabla de REsultados -------------------->
                <div class="text-left ml-4">
                  Cant. Resultados: 
                  <span class="badge badge-info text-white">
                    {{ tablaProducto.count }}
                  </span>
                </div>
                <table class="table table-striped mt-2">
                  <thead
                    style="
                      position: -webkit-sticky;
                      position: sticky;
                      top: 0;
                      z-index: 10;
                      background: #fff;
                    "
                  >
                    <tr>
                      <th class="text-center">SKU</th>
                      <th class="text-center">Producto</th>                      
                      <th class="text-center">Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(detalle, indexDetalle) in tablaProducto.results"
                      v-bind:key="indexDetalle"
                    >
                      <td v-if="detalle.estatus == false" class="text-center">
                        {{ detalle.producto }}
                      </td>
                      <td v-if="detalle.estatus == false" class="text-center">
                        {{ detalle.producto_nombre }}
                      </td>                      
                      <td class="text-center" v-if="detalle.estatus == false">
                        <button
                          @click="
                            agregarDetalle(detalle)
                          "
                          class="btn btn-primary btn-sm text-white"
                        >
                           <i class="fas fa-plus text-white"></i>
                          Agregar &nbsp;
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>             

                <h5 v-if="success" class="text-success">
                  Guardado exitosamente! <i class="fas fa-check-double"></i>
                </h5>
                <!-------------------- END - Basic Table -------------------->
                

                <PaginationComponent :currentPage="currentPage" :data="tablaProducto" 
                @pagechanged="onPageChange" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              @click="cerrarModal()"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import SubCategoriaSelectComponent from "@/components/commons/SubCategoriaSelectComponent ";
import CategoriaSelectComponent from "@/components/commons/CategoriaSelectComponent ";
import Notifications from "@/notifications/notifications";
import PaginationComponent from "@/components/utils/PaginationComponent";

export default {
  components: {
    ProductoSelectComponent,
    ProveedoresSelectComponent,
    SubCategoriaSelectComponent,
    PaginationComponent,
    CategoriaSelectComponent,
  },
  data() {
    return {
      filter: {
        // producto:"",
        // subcategoria :"",
        // categoria :"",
        // proveedor :"",
      },
      success: false,
      tablaProducto: "",
      currentDetalle: {
        producto: "",
      },  
      currentPage: 1,  
      errors:null
    };
  },
    watch:{ 
      "filter.producto"(val){        
        if(!val){          
          this.tablaProducto= ""
          this.errors=null
        }
      },
      "filter.subcategoria"(val){        
        if(!val){          
          this.tablaProducto= ""
          this.errors=null
        }
      },
      "filter.categoria"(val){        
        if(!val){          
          this.tablaProducto= ""
          this.errors=null
        }
      },
      "filter.proveedor"(val){        
        if(!val){          
          this.tablaProducto= ""
          this.errors=null
        }
      },
    },
  mounted() {
      
    
  },
  props: ["current","listaProductos"],
  methods: {
    cerrarModal() {
      let self = this;
      $("#nuevaOrdenCompraModal").modal("hide");
      self.tablaProducto = "";
    },
    cleanDataFilter() {
      let self = this;
      console.log("Limpiando filtros");
      self.tablaProducto = "";
      self.filter.producto = null;
      self.filter.subcategoria = null;
      self.filter.categoria = null;
      self.filter.proveedor = null;
      self.errors = null
    },
    agregar_lista_productos(){      
      let self = this; 

      let filtro = Object.assign({}, this.filter);
      if (filtro.producto) {
        filtro.producto = filtro.producto.sku;
      }
      if (filtro.proveedor) {
        filtro.proveedor = filtro.proveedor.codigo;
      }
      if (filtro.subcategoria) {
        filtro.subcategoria = filtro.subcategoria.codigo;
      }
      let params = {}     
      params = filtro
      params.cuponera = self.current.id

      console.log("params", params)

      DynamicService.postActionList(
        "cat",
        "cuponera",
        "guardar_lista_productos",
        params
      ).then((response) => {        
        if(response.status == 200){
          Notifications.alert.success(
            "Agregar listado de productos", 
            "El listado fue agregado con éxito" 
          )
          this.$emit("refreshCuponeraSku",{page:1})
          this.refreshtablaAgregarProductos()
        }        
        
        
      }).catch((error) => {
     
        Notifications.alert.error(
          "Agregar listado de productos", 
          error.response
        )
      })

    },
    refreshtablaAgregarProductos(parametros) {
      let filtro = Object.assign({}, this.filter);
      if (filtro.producto) {
        filtro.producto = filtro.producto.sku;
      }
      if (filtro.proveedor) {
        filtro.proveedor = filtro.proveedor.codigo;
      }
      if(filtro.categoria){
        filtro.categoria = filtro.categoria.codigo
      }
      if (filtro.subcategoria) {
        filtro.subcategoria = filtro.subcategoria.codigo;
      }

      console.log("filtro", filtro)
      console.log("current.id", this.current.id)
      let params = {}
      
      if(parametros){        
        params = filtro  
        params.page = parametros.page
      }
      else{
        params = filtro
        params.page = 1
      }
      
      params.cuponera = this.current.id     
      console.log("params", params)

      DynamicService.getActionList(
        "cat",
        "cuponera",
        "traer_productos_proveedor_paginados",        
        params
      ).then((response) => {        
        this.tablaProducto = response.data;   
        console.log("tablaProducto", this.tablaProducto)      
      }).catch((error) => {
        this.errors = error.response.data.error  
        console.log("Error", this.errors)
        this.tablaProducto = ""
      }
      );
    },
    abrirModalAgregarDetalle() {
      $("#nuevaOrdenCompraModal").modal("show");
    },
    agregarDetalle(producto) {
      let self = this     
      let params = {
        cuponera: self.current.id,
        producto: producto.producto,
      }   

      producto.estatus=true      
      DynamicService.postActionList("cat", "cuponera-sku", "guardar_detalle_cuponera_sku", params)
      .then((response)=>{    
        this.$emit("refreshCuponeraSku",{page:1})    
        Notifications.alert.success("Producto agregado",
          "El producto " + producto.producto + " se agregó correctamente al cupón" 
        )
        self.refreshtablaAgregarProductos()
      }).catch((error)=>{
        Notifications.alert.error(
          "Error al agregar producto", 
          error.response.data.error
        )
      })  
    },
    onPageChange(page) {
      let self=this      
      this.currentPage = page;
      self.refreshtablaAgregarProductos({
        page: this.currentPage
      }); 
    },
  },
};
</script>
